import React from "react"
import classNames from "classnames"
import NavbarUserDropdown from "./NavbarUserDropdown"
import {NavbarEnvironmentIndicator} from "./Navbar"
import LogoLight from "../../images/logo-light.svg"

type Props = {
	className?: string
}

export default function SetupNavbar({className}: Props) {
	return (
		<nav className={classNames("navbar align-items-center", className)}>
			<div className="navbar-logo-wrapper">
				<span className="logo-wrapper">
					<img src={LogoLight} alt={"Unit"} />
				</span>
				<NavbarEnvironmentIndicator isExpanded={true} />
			</div>
			<NavbarUserDropdown narrow />
		</nav>
	)
}
